import { FC, useCallback, useEffect, useState } from "react";
import { useModal } from "../../../core";
import { CloseModalIcon } from "../../../core/modules/CloseIconNew";
import { API, Endpoints } from "@brg/api";
import { BrgButton, ButtonVariant, useToasts } from "@brg/ui";
import { Trans, useTranslation } from "react-i18next";
import {
    TransferModalBodyLink,
    CloseModalIconWrapper,
    TransferModalHeaderRow,
    TransferModalTitleMain,
    TransferModalDescription,
    TransferLinkInputWrapperAtBottom,
    TransferLinkInput,
    Divider,
    InstructionsList,
    BottomGroup,
} from "../TransferProjectModal/styles";

export interface ExportProjectsModalProps {
    selectedByTab?: Record<string, string[]>;
}

export const ExportProjectsModal: FC<ExportProjectsModalProps> = ({ selectedByTab }) => {
    const modal = useModal();
    const toasts = useToasts();
    const { t } = useTranslation();
    const [link, setLink] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [loadError, setLoadError] = useState<string | null>(null);

    const fullLink = link ?? "";

    const allSelectedIds = selectedByTab
        ? Object.values(selectedByTab).flat()
        : [];

    useEffect(() => {
        if (!allSelectedIds.length) {
            setIsLoading(false);
            return;
        }
        setIsLoading(true);
        setLoadError(null);

        API.request()
            .endpoint(Endpoints.geograffee)
            .url("/api/DataTransfer/ExportManyProjects")
            .body(allSelectedIds)
            .post()
            .send()
            .then((r: Response) => (r?.ok ? r.text() : Promise.reject()))
            .then((code: string) => {
                const trimmed = code?.trim() ?? "";
                const withoutQuotes = trimmed.replace(/^"|"$/g, "");
                setLink(withoutQuotes || null);
            })
            .catch(() => {
                const msg = t("transfer_project_modal.error_load");
                setLoadError(msg);
                toasts.error(msg);
            })
            .finally(() => {
                setIsLoading(false);
            });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onCopy = useCallback(() => {
        if (!fullLink) return;
        navigator.clipboard.writeText(fullLink).then(
            () => toasts.info(t("link_copied")),
            () => toasts.error(t("transfer_project_modal.error_copy")),
        );
    }, [fullLink, toasts, t]);

    const onClose = useCallback(() => modal.hide(), [modal]);

    const isReady = !!link;

    return (
        <TransferModalBodyLink>
            <TransferModalHeaderRow>
                <TransferModalTitleMain>
                    {isReady
                        ? t("export_projects_modal.title")
                        : t("export_projects_modal.title_loading")}
                </TransferModalTitleMain>
                <CloseModalIconWrapper>
                    <CloseModalIcon onClick={onClose} width={22} height={22} />
                </CloseModalIconWrapper>
            </TransferModalHeaderRow>

            {isReady && (
                <>
                    <InstructionsList>
                        <TransferModalDescription as="li">
                            {t("export_projects_modal.copy_code")}
                        </TransferModalDescription>
                        <TransferModalDescription as="li">
                            {t("export_projects_modal.login_to_platform")}
                        </TransferModalDescription>
                        <TransferModalDescription as="li">
                            <Trans i18nKey="export_projects_modal.select_import" />
                        </TransferModalDescription>
                    </InstructionsList>
                    <Divider />
                </>
            )}
            <BottomGroup>
                {isReady && (
                    <TransferModalDescription>
                        {t("export_projects_modal.description")}
                    </TransferModalDescription>
                )}
                <TransferLinkInputWrapperAtBottom>
                    <TransferLinkInput
                        type="text"
                        readOnly
                        value={fullLink}
                        placeholder={t("transfer_project_modal.placeholder")}
                    />
                    <BrgButton
                        variant={ButtonVariant.Filled}
                        disabled={!isReady}
                        onClick={onCopy}
                    >
                        {t("transfer_project_modal.copy")}
                    </BrgButton>
                </TransferLinkInputWrapperAtBottom>
            </BottomGroup>
        </TransferModalBodyLink>
    );
};
import { FC, useCallback, useEffect, useState } from "react";
import { useModal } from "../../../core";
import { CloseModalIcon } from "../../../core/modules/CloseIconNew";
import { API, Endpoints } from "@brg/api";
import { BrgButton, ButtonVariant, useToasts } from "@brg/ui";
import { Trans, useTranslation } from "react-i18next";
import {
    TransferModalBodyLink,
    CloseModalIconWrapper,
    TransferModalHeaderRow,
    TransferModalTitleMain,
    TransferModalDescription,
    TransferLinkInputWrapperAtBottom,
    TransferLinkInput,
    Divider,
    InstructionsList,
    BottomGroup,
} from "../TransferProjectModal/styles";

export interface ExportProjectsModalProps {
    selectedByTab?: Record<string, string[]>;
}

export const ExportProjectsModal: FC<ExportProjectsModalProps> = ({ selectedByTab }) => {
    const modal = useModal();
    const toasts = useToasts();
    const { t } = useTranslation();
    const [link, setLink] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [loadError, setLoadError] = useState<string | null>(null);

    const fullLink = link ?? "";

    const allSelectedIds = selectedByTab
        ? Object.values(selectedByTab).flat()
        : [];

    useEffect(() => {
        if (!allSelectedIds.length) {
            setIsLoading(false);
            return;
        }
        setIsLoading(true);
        setLoadError(null);

        API.request()
            .endpoint(Endpoints.geograffee)
            .url("/api/DataTransfer/ExportManyProjects")
            .body(allSelectedIds)
            .post()
            .send()
            .then((r: Response) => (r?.ok ? r.text() : Promise.reject()))
            .then((code: string) => {
                const trimmed = code?.trim() ?? "";
                const withoutQuotes = trimmed.replace(/^"|"$/g, "");
                setLink(withoutQuotes || null);
            })
            .catch(() => {
                const msg = t("transfer_project_modal.error_load");
                setLoadError(msg);
                toasts.error(msg);
            })
            .finally(() => {
                setIsLoading(false);
            });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onCopy = useCallback(() => {
        if (!fullLink) return;
        navigator.clipboard.writeText(fullLink).then(
            () => toasts.info(t("link_copied")),
            () => toasts.error(t("transfer_project_modal.error_copy")),
        );
    }, [fullLink, toasts, t]);

    const onClose = useCallback(() => modal.hide(), [modal]);

    const isReady = !!link;

    return (
        <TransferModalBodyLink>
            <TransferModalHeaderRow>
                <TransferModalTitleMain>
                    {isReady
                        ? t("export_projects_modal.title")
                        : t("export_projects_modal.title_loading")}
                </TransferModalTitleMain>
                <CloseModalIconWrapper>
                    <CloseModalIcon onClick={onClose} width={22} height={22} />
                </CloseModalIconWrapper>
            </TransferModalHeaderRow>

            {isReady && (
                <>
                    <InstructionsList>
                        <TransferModalDescription as="li">
                            {t("export_projects_modal.copy_code")}
                        </TransferModalDescription>
                        <TransferModalDescription as="li">
                            {t("export_projects_modal.login_to_platform")}
                        </TransferModalDescription>
                        <TransferModalDescription as="li">
                            <Trans i18nKey="export_projects_modal.select_import" />
                        </TransferModalDescription>
                    </InstructionsList>
                    <Divider />
                </>
            )}
            <BottomGroup>
                {isReady && (
                    <TransferModalDescription>
                        {t("export_projects_modal.description")}
                    </TransferModalDescription>
                )}
                <TransferLinkInputWrapperAtBottom>
                    <TransferLinkInput
                        type="text"
                        readOnly
                        value={fullLink}
                        placeholder={t("transfer_project_modal.placeholder")}
                    />
                    <BrgButton
                        variant={ButtonVariant.Filled}
                        disabled={!isReady}
                        onClick={onCopy}
                    >
                        {t("transfer_project_modal.copy")}
                    </BrgButton>
                </TransferLinkInputWrapperAtBottom>
            </BottomGroup>
        </TransferModalBodyLink>
    );
};
